'use client';

import { SessionProvider } from 'next-auth/react';
import { ReactNode } from 'react';
import { AUTH_CONFIG } from '@/config/app';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  return (
    <SessionProvider
      basePath={AUTH_CONFIG.basePath}
      refetchInterval={60}
      refetchOnWindowFocus={true}
    >
      {children}
    </SessionProvider>
  );
}
